import React from 'react';
import Lottie from 'lottie-react';

import './LoadingScreen.css';
import LoadingAnimation from '../../../Assets/Animation/loading-screen.json'

const LoadingScreen = () => {
  return (
    <div className='loading_screen_container mues_row_center'>
        <Lottie className='loading_screen_animation' animationData={LoadingAnimation}/>
    </div>
  )
}

export default LoadingScreen